import type { TupleToUnion } from "type-fest";

export const GAME_MODES = ["classic", "mcq", "pairs", "imcq"] as const;
export type GameMode = TupleToUnion<typeof GAME_MODES>;
